<!--网点输入搜索-->
<template>
  <div>
    <el-autocomplete class="inline-input"
                     v-if="show"
                     v-model="siteName"
                     :fetch-suggestions="querySiteSearch"
                     placeholder=""
                     :trigger-on-focus="false"
                     @select="handleSiteSelect"
                     :clearable="true"
                     @clear="handleEmpty"
    />
    <el-input v-else size="small" v-model="showSiteName" :disabled="true"/>
  </div>
</template>

<script>
import api from "@/api/projectApi";

export default {
  name: 'siteSearch',
  props: {
    siteId: {
      required: true
    },
    show: {
      default: true
    },
    showSiteName: {},
    orgId: [String, Number],
  },
  components: {},
  data() {
    return {
      siteName: null,
      selectedRow: {
        id: '', name: '', orgId: null, orgIdPath: null,orgName: null,showOrg: false
      },
    }
  },

  watch: {
    siteName: {
      handler(newVal) {
        if (newVal == null || newVal == '' || newVal == undefined) {
          this.$emit('update:siteId', null)
        }
      },
      deep: true,
      immediate: false,
    },
    siteId:{
      handler(newVal) {
        if (newVal == null || newVal == '' || newVal == undefined) {
          this.siteName = null
        }
      },
      deep: true,
      immediate: false,
    },

  },


  methods: {
    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$mask.open()
      console.log("机构---"+this.orgId)
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr,orgId: this.orgId}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
      if(this.orgId){
        this.selectedRow.showOrg = true;
      }else {
        this.selectedRow.showOrg = false;
      }
      this.$mask.close()

    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('选中数据', data)

      //根据网点查询出机构
      this.$http({
        url: api.snUser.getDataUrl,
        method: 'post',
        data: {id:data.id}
      }).then(res => {
        console.log('获取网点机构信息', res.data.data)
        this.selectedRow.id = data.id
        this.selectedRow.name = data.value
        this.selectedRow.orgId = res.data.data.snSiteInfoDTO.orgId
        this.selectedRow.orgIdPath = res.data.data.snSiteInfoDTO.orgIdPath
        this.selectedRow.orgName = res.data.data.snSiteInfoDTO.orgName
        this.$emit('commit', this.selectedRow)
      })
    },

    handleEmpty(){
      console.log("清空数据-----"+this.selectedRow.showOrg)
      if(!this.selectedRow.showOrg){
        this.selectedRow.orgId = null
        this.selectedRow.orgIdPath = null
        this.selectedRow.orgName = null
        this.selectedRow.showOrg = true;
        this.$emit('commit', this.selectedRow)
      }
    },
  },
};
</script>

<style scoped lang="scss">

</style>
